import { createGetAsyncSlice } from '@sonar-software/xuder';
import { getApiGatewayKeys } from '@api/data-security';

export const getCoreApiGatewayKeysSlice = createGetAsyncSlice({
	name: 'CoreApiGatewayKeys',
	receive: true,
	request: true,
	requestHandler: getApiGatewayKeys,
	retainDataOnRequest: true
});
